<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" class="mt-6 mb-8">
        <h3 class="gray--text mb-4">Seguro Agrícola Produtividade</h3>
        <v-data-table
          :headers="headerProductivity"
          :items="getQuotationProductivity"
          no-data-text="Nenhuma Cotação foi encontrada"
          loading-text="Carregando Cotações..."
          :options.sync="options"
          :server-items-length="getQuotationProductivity.length"
          class="quotation-table base__datatable cursor-agricola"
          item-key="item.index"
          :footer-props="{ 'items-per-page-options': [25, 50, 100, 250, 500] }"
          :hide-default-footer="true"
        >
          <template v-slot:[`item.index`]="{ item }">
            {{ "1." + (getQuotationProductivity.indexOf(item) + 1) }}
          </template>
          <template v-slot:[`item.insuredArea`]="{ item }">
            {{ asNumberString(item.insuredArea) }}
          </template>
          <template v-slot:[`item.insuredValue`]="{ item }">
            {{ asNumberString(item.insuredValue) }}
          </template>
          <template v-slot:[`item.grantedProduction`]="{ item }">
            {{ asNumberString(item.grantedProduction) }}
          </template>
          <template v-slot:[`item.costPerSac`]="{ item }">
            {{ asNumberString(item.costPerSac) }}
          </template>
          <template v-slot:[`item.total`]="{ item }">
            {{ asNumberString(item.total) }}
          </template>
          <template v-slot:[`item.federalSubvention`]="{ item }">
            {{ asNumberString(item.federalSubvention) }}
          </template>
          <template v-slot:[`item.stateSubvention`]="{ item }">
            {{ asNumberString(item.stateSubvention) }}
          </template>
          <template v-slot:[`item.insuredPrice`]="{ item }">
            {{ asNumberString(item.insuredPrice) }}
          </template>
          <template v-slot:[`item.farmerPrice`]="{ item }">
            {{ asNumberString(item.farmerPrice) }}
          </template>
          <template v-slot:[`item.visible`]="{ item }">
            <v-row class="buttonAction">
              <v-col>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="editRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fas fa-pencil-alt </v-icon>
                    </BaseButton>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
              </v-col>
              <v-col>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="deleteRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fas fa-trash-alt </v-icon>
                    </BaseButton>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-col>
              <v-col>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="duplicateRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fa-thin fa-copy </v-icon>
                    </BaseButton>
                  </template>
                  <span>Duplicar</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <ModalDeleteLineTable v-model="showDeleteModal" @close="closeModal" />
    <v-row>
      <v-col cols="12" class="mb-8">
        <h3 class="gray--text mb-4">Seguro Agrícola Custeio</h3>
        <v-data-table
          :headers="headerCosting"
          :items="getQuotationCosting"
          no-data-text="Nenhuma Cotação foi encontrada"
          loading-text="Carregando Cotações..."
          :options.sync="options"
          :server-items-length="getQuotationCosting.length"
          class="quotation-table base__datatable cursor-agricola"
          item-key="item.index"
          :footer-props="{ 'items-per-page-options': [25, 50, 100, 250, 500] }"
          :hide-default-footer="true"
        >
          <template v-slot:[`item.index`]="{ item }">
            {{ "2." + (getQuotationCosting.indexOf(item) + 1) }}
          </template>
          <template v-slot:[`item.insuredArea`]="{ item }">
            {{ asNumberString(item.insuredArea) }}
          </template>
          <template v-slot:[`item.insuredValue`]="{ item }">
            {{ asNumberString(item.insuredValue) }}
          </template>
          <template v-slot:[`item.grantedProduction`]="{ item }">
            {{ asNumberString(item.grantedProduction) }}
          </template>
          <template v-slot:[`item.hectareCost`]="{ item }">
            {{ asNumberString(item.hectareCost) }}
          </template>
          <template v-slot:[`item.total`]="{ item }">
            {{ asNumberString(item.total) }}
          </template>
          <template v-slot:[`item.federalSubvention`]="{ item }">
            {{ asNumberString(item.federalSubvention) }}
          </template>
          <template v-slot:[`item.stateSubvention`]="{ item }">
            {{ asNumberString(item.stateSubvention) }}
          </template>
          <template v-slot:[`item.insuredPrice`]="{ item }">
            {{ asNumberString(item.insuredPrice) }}
          </template>
          <template v-slot:[`item.farmerPrice`]="{ item }">
            {{ asNumberString(item.farmerPrice) }}
          </template>
          <template v-slot:[`item.visible`]="{ item }">
            <v-row class="buttonAction">
              <v-col>
                <v-tooltip bottom offset-y="24">
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="editRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fas fa-pencil-alt </v-icon>
                    </BaseButton>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
              </v-col>
              <v-col>
                <v-tooltip bottom offset-y="24">
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="deleteRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fas fa-trash-alt </v-icon>
                    </BaseButton>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-col>
              <v-col>
                <v-tooltip bottom offset-y="24">
                  <template v-slot:activator="{ on }">
                    <BaseButton
                      color="secondary"
                      class="base-input-file__button mr-1 px-0"
                      @click="duplicateRow(item)"
                      v-on="on"
                    >
                      <v-icon size="12"> fa-thin fa-copy </v-icon>
                    </BaseButton>
                  </template>
                  <span>Duplicar</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row
      class="d-flex justify-end"
      v-if="currentQuotation.cancelada_em == null"
    >
    </v-row>
  </v-form>
</template>
<script>
const tableHeadersProductivity = [
  { text: "Id", value: "index", sortable: false, width: "4px" },
  { text: "Seguradora", value: "insuranceCompany.nome", sortable: false, width: "90px" },
  { text: "Área (ha)", value: "insuredArea", sortable: false },
  { text: "Regulação Sinistro", value: "claimType.nome", sortable: false },
  { text: "Coberturas", value: "coverage.nome", sortable: false },
  { text: "Importância Segurada R$", value: "insuredValue", sortable: false },
  {
    text: "Produtividade Garantida",
    value: "grantedProduction",
    sortable: false,
    width: "80px"
  },
  { text: "Preço da Saca R$", value: "costPerSac", sortable: false },
  { text: "Preço Total R$", value: "total", sortable: false },
  { text: "Subvenção Federal R$", value: "federalSubvention", sortable: false },
  { text: "Subvenção Estadual R$", value: "stateSubvention", sortable: false },
  { text: "Preço do Segurado R$", value: "insuredPrice", sortable: false },
  { text: "Preço do Produtor (sc/R$)", value: "farmerPrice", sortable: false },
  { text: "Forma de Pagamento", value: "paymentForm.nome", sortable: false },
  { text: "Ações", value: "visible", sortable: false }
];
const tableHeadersCosting = [
  { text: "Id", value: "index", sortable: false, width: "4px" },
  { text: "Seguradora", value: "insuranceCompany.nome", sortable: false, width: "90px" },
  { text: "Área (ha)", value: "insuredArea", sortable: false },
  { text: "Regulação Sinistro", value: "claimType.nome", sortable: false },
  { text: "Coberturas", value: "coverage.nome", sortable: false },
  { text: "Importância Segurada R$", value: "insuredValue", sortable: false },
  {
    text: "Produtividade Garantida",
    value: "grantedProduction",
    sortable: false,
    width: "80px"
  },
  { text: "Custo por Hectare R$", value: "hectareCost", sortable: false },
  { text: "Preço Total R$", value: "total", sortable: false },
  { text: "Subvenção Federal R$", value: "federalSubvention", sortable: false },
  { text: "Subvenção Estadual R$", value: "stateSubvention", sortable: false },
  { text: "Preço do Segurado R$", value: "insuredPrice", sortable: false },
  { text: "Preço do Produtor (sc/R$)", value: "farmerPrice", sortable: false },
  { text: "Forma de Pagamento", value: "paymentForm.nome", sortable: false },
  { text: "Ações", value: "visible", sortable: false }
];
const colorByStatus = [
  { color: "pink", status: "cancelada" },
  { color: "blue", status: "apolice_emitida" },
  { color: "light-blue", status: "aguardando_emissao_minuta" },
  { color: "light-blue", status: "aguardando_analise_minuta" },
  { color: "yellow", status: "em_andamento" }
];
const DEFAULT_STATUS = { color: "yellow" };

import {
  asNumberString,
  formatExpirationDate,
  formatDDMMYYYYToIsoDate
} from "@/utils/formats.js";
import { mapState, mapActions } from "vuex";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { maskDate } from "@/utils/masks.js";
import { dateTermValid, requiredInput } from "@/utils/rules.js";
import { CommonPayload } from "@/mixins/PayloadDataTableMixin";
import ModalDeleteLineTable from "../components_agro/ModalDeleteLineTable.vue";
export default {
  data() {
    return {
      headerProductivity: tableHeadersProductivity,
      headerCosting: tableHeadersCosting,
      listColorByStatus: colorByStatus,
      formatExpirationDate,
      maskDate,
      timeout: null,
      dateTermValid,
      formatDDMMYYYYToIsoDate,
      initializeFilter: false,
      currentTab: 1,
      requiredInput,
      asNumberString,
      selectedItem: null,
      showDeleteModal: false,
      shouldDeleteData: false
    };
  },
  components: {
    ModalDeleteLineTable
  },
  props: {
    value: {
      type: Object
    }
  },
  mixins: [LoadingRequest, CommonPayload],
  computed: {
    ...mapState("quotation", [
      "infoCostQuotation",
      "currentQuotation",
      "statusCurrentQuotation",
      "listQuotation"
    ]),
    ...mapState(["nameOptionsDataTable", "filterDataTable"]),
    formCosts: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    getQuotationProductivity() {
      return this.formCosts.quotationCosts.filter(
        a => a.insuranceType?.id == "produtividade"
      );
    },
    getQuotationCosting() {
      return this.formCosts.quotationCosts.filter(
        a => a.insuranceType?.id == "custeio"
      );
    }
  },
  methods: {
    ...mapActions("quotation", [
      "requestCurrentQuotation",
      "requestStatusCurrentQuotation",
      "requestListQuotation"
    ]),
    borderColor(item) {
      const status =
        this.listColorByStatus.find(x => x.status == item.id) || DEFAULT_STATUS;
      return `quotation-table__border-${status.color}`;
    },
    redirectToQuotation(item) {
      this.saveOptionsDataTable(this.payloadOptions(this.currentTab));
      this.$router.push({ name: "quotation element", params: { id: item.id } });
    },
    async fetchStatusQuotation() {
      await this.requestStatusCurrentQuotation(this.$route.params.id);
    },
    editRow(item) {
      this.$emit("edit", item);
    },
    closeModal(valor) {
      this.shouldDeleteData = valor;
      this.showDeleteModal = false;
      this.$emit("modal-closed");
    },
    deleteRow(item) {
      this.showDeleteModal = true;

      this.$once("modal-closed", () => {
        if (this.shouldDeleteData) {
          this.$emit("delete", item);
        }
      });
    },
    duplicateRow(item) {
      this.$emit("duplicate", item);
    }
  }
};
</script>
<style lang="sass">
.quotation-table__
  &checkbox
    label
      font-size: 8px !important
      font-weight: 300
      color: #676778 !important
  &border-blue
    border-left: 5px solid #059EE4
  &border-light-blue
    border-left: 5px solid #49DCBB
  &border-yellow
    border-left: 5px solid #FFC55F
  &border-pink
    border-left: 5px solid #EF5350
  &padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.quotation-table
  min-width: 90% !important
  background-color: #FFFFFF !important
  table
    table-layout: fixed
    width: 100% !important
    overflow-x: none
.base__datatable.v-data-table.theme--light
  thead tr th
    font-size: 10px
    padding-rigth: 6px
  thead tr th:first-child
    padding-left: 2px
.quotation-table.v-data-table.theme--light
  thead th
    font-size: 1px
  thead tr th:last-child
    font-size: 11px
    padding-left: 50px
    width: 150px
  tbody tr td:first-child
    padding: 2px 0px 2px 4px !important
    align-items: center
  tbody tr td
    padding-left: 15px
    align-items: center
.toolbar-quotation-info
  display: flex
  justify-content: right
.cursor-agricola
  tbody tr td
    cursor: default
    font-size: 10px !important
.buttonAction
  display: flex
  flex-wrap: nowrap
</style>
